export default __webpack_public_path__ + "static/media/add-check.16970aac.svg";